import { EditFilled, UserOutlined } from "@ant-design/icons";
import { useMutation, useQuery } from "@apollo/react-hooks";
import {
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  message,
  Row,
  Spin,
  Tooltip,
  Upload,
} from "antd";
import { React, useEffect, useState } from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { useHistory, useParams } from "react-router";
import { Loader } from "../../../../Components/Loader";
import { ShiftTiming } from "../../../../Components/ShiftTiming/ShiftTiming";
import { UPDATE_EMPLOYEE_DETAILS } from "../../../../Graphql/mutations";
import { GET_USER_DETAILS } from "../../../../Graphql/queries";
import "./EmployeePersonalDetails.less";
const { REACT_APP_ASSETS_URL } = process.env;

export const EmployeePersonalDetailsPage = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const { employee_id } = useParams();
  const [locationOptions, setLocationOptions] = useState({});
  const { data: userData, loading } = useQuery(GET_USER_DETAILS, {
    variables: {
      user_id: employee_id,
    },
  });

  const [UPDATE_EMPLOYEE_DETAILS_MUTATION, { loading: isUpdating }] =
    useMutation(UPDATE_EMPLOYEE_DETAILS);

  useEffect(() => {
    if (userData) {
      form.setFieldsValue({
        user_id: userData.getUsersById.user_id,
        first_name: userData.getUsersById.first_name,
        last_name: userData.getUsersById.last_name,
        email: userData.getUsersById.email,
        phone: userData.getUsersById.phone,
        employee_code: userData.getUsersById.employee_code,
        profile_image: userData.getUsersById.profile_image,
        shift_timing: userData.getUsersById.user_shifts,
      });
      let locationList = userData.getUsersById.user_location_maps.flatMap(
        ({
          locationDetails: { location_id, location_name, location_timings },
        }) => {
          return [
            {
              location_id,
              location_name,
              workingHours: {
                openingTime:
                  location_timings.length &&
                  location_timings.reduce(
                    (min, curr) =>
                      curr.opening_time < min ? curr.opening_time : min,
                    location_timings[0].opening_time
                  ),
                closingTime:
                  location_timings.length &&
                  location_timings.reduce(
                    (max, curr) =>
                      curr.closing_time > max ? curr.closing_time : max,
                    location_timings[0].closing_time
                  ),
              },
            },
          ];
        }
      );
      setLocationOptions(locationList[0].workingHours);
    }
  }, [userData]);

  if (loading) {
    return <Loader />;
  }

  const onUpdateUser = async (values) => {
    values.shift_timing = values.shift_timing.flatMap(
      ({ working_day, start_time, end_time }) => [
        { working_day, start_time, end_time, user_id: values.user_id },
      ]
    );
    try {
      const isUpdateSuccessful = await UPDATE_EMPLOYEE_DETAILS_MUTATION({
        variables: {
          user_id: values.user_id,
          user_details: {
            first_name: values.first_name,
            last_name: values.last_name,
            email: values.email,
            phone: values.phone,
            employee_code: values.employee_code,
            profile_image: values.profile_image,
          },
          shifts: values.shift_timing,
        },
      });

      if (!isUpdateSuccessful.errors) {
        message.success("Employee Details Updated Successfully!");
      } else {
        message.error("Something went wrong. Please try again later.");
      }
    } catch (error) {}
  };

  return (
    <>
      <div className="secSubTitle pageSubTilte">
        <div className="stLeft">
          <h5 className="">Edit profile</h5>
        </div>
      </div>
      <Form form={form} onFinish={onUpdateUser} className="">
        <div className="profileInContainer">
          <Row justify="center mt-5">
            <Form.Item name="user_id" style={{ display: "none" }}></Form.Item>
            <Form.Item name="profile_image" noStyle>
              <div className="position-relative">
                {!userData?.getUsersById?.profile_image ? (
                  <Avatar
                    //  icon={<UserOutlined />}
                    size={100}
                    className="userAvatar"
                  >
                    {userData ? (
                      userData.getUsersById.first_name.charAt(0) +
                      userData.getUsersById.last_name.charAt(0)
                    ) : (
                      <UserOutlined />
                    )}
                  </Avatar>
                ) : (
                  <Avatar
                    src={
                      REACT_APP_ASSETS_URL + userData.getUsersById.profile_image
                    }
                    icon={<UserOutlined />}
                    size={100}
                    className="userAvatar"
                  ></Avatar>
                )}
                <Upload>
                  <Button
                    type="primary"
                    className="editButton"
                    icon={<EditFilled />}
                  ></Button>
                </Upload>
              </div>
            </Form.Item>
          </Row>
          <Row className="mt-4 mx-sm-3" gutter={16}>
            <Col xs={24} sm={12}>
              <Tooltip
                trigger={["focus"]}
                title="First Name"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item
                  name="first_name"
                  rules={[
                    {
                      required: true,
                      message: "First Name is required",
                      whitespace: true,
                    },
                    {
                      pattern: new RegExp(
                        "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$"
                      ),
                      message: "Invalid First name",
                    },
                  ]}
                >
                  <Input name="firstname" placeholder="First Name" />
                </Form.Item>
              </Tooltip>
            </Col>
            <Col xs={24} sm={12}>
              <Tooltip
                trigger={["focus"]}
                title="Last Name"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item
                  name="last_name"
                  rules={[
                    {
                      required: true,
                      message: "First Name is required",
                      whitespace: true,
                    },
                    {
                      pattern: new RegExp(
                        "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$"
                      ),
                      message: "Invalid First name",
                    },
                  ]}
                >
                  <Input name="lastname" placeholder="Last Name" />
                </Form.Item>
              </Tooltip>
            </Col>
            <Col xs={24} sm={12}>
              <Tooltip
                trigger={["focus"]}
                title="Employee Code"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item
                  name="employee_code"
                  rules={[
                    {
                      required: true,
                      message: "Employee Code is required",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input name="code" placeholder="Employee Code" />
                </Form.Item>
              </Tooltip>
            </Col>
            {/* <Col span={12}>
          <Tooltip
            trigger={["focus"]}
            title="Employee Role"
            placement="topLeft"
            overlayClassName="numeric-input"
          >
            <Form.Item
              name="role_id"
              hasFeedback
              rules={[{ required: true, message: "Please select a user role" }]}
            >
              <Input name="code" placeholder="Employee Role" />
            </Form.Item>
          </Tooltip>
        </Col> */}
            <Col xs={24} sm={12}>
              <Tooltip
                trigger={["focus"]}
                title="Email"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Email Address is required",
                      whitespace: true,
                    },
                    {
                      type: "email",
                      message: "Enter Valid Email Address",
                    },
                  ]}
                >
                  <Input readOnly name="email" placeholder="Email" />
                </Form.Item>
              </Tooltip>
            </Col>
            <Col xs={24} sm={12}>
              <Tooltip
                trigger={["focus"]}
                title="Phone"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item
                  name="phone"
                  rules={[
                    {
                      required: true,
                      message: "Phone Number is required",
                      whitespace: true,
                    },
                    () => ({
                      validator(_, value) {
                        if (value && isValidPhoneNumber(value)) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Enter Valid Phone Number")
                        );
                      },
                    }),
                  ]}
                >
                  <PhoneInput
                    readOnly
                    className="phoneInput_blk"
                    defaultCountry="US"
                    placeholder="(201) 555-1234"
                    countryOptionsOrder={["US", "CA", "|", "..."]}
                  />
                </Form.Item>
              </Tooltip>
            </Col>

            <Col span={24} className="d-flex justify-content-center">
              <Button
                shape="round"
                size="large"
                className="mr-2 backBtn text-black"
                onClick={() => history.goBack()}
              >
                Back
              </Button>
              <Button
                loading={isUpdating}
                type="primary"
                htmlType="submit"
                shape="round"
                size="large"
                className=""
              >
                {isUpdating ? "Saving.." : "Save"}
              </Button>
            </Col>
          </Row>
        </div>
        <Divider />
        <Form.Item
          name="shift_timing"
          rules={[
            {
              required: true,
              message: "Shift Timing is required",
              whitespace: true,
              type: "array",
            },
          ]}
        >
          <div className="emplyshiftTiming">
            <div className="secSubTitle pageSubTilte">
              <div className="stLeft">
                <h5>Shift schedule</h5>
              </div>
              <div className="stright d-flex align-items-center"></div>
            </div>

            <Card>
              <ShiftTiming
                userType={
                  userData.getUsersById?.user_location_maps[0]?.jobRoleDetails
                    ?.accessDetails?.type_id
                }
                locationHours={locationOptions}
                initialValue={userData.getUsersById.user_shifts}
                updateFormValue={form.setFieldsValue}
              />
            </Card>
          </div>
        </Form.Item>
      </Form>
    </>
  );
};
